<template>
  <div class="play-area overflow-hidden">
    <resize-observer @notify='resizeListener' />
    <div class="gamecanvas" />
  </div>
</template>
<script>
const Util = require('@/play/game/util.js');
const EntityManager = require('pbc-ecs').EntityManager;
import CreateSystems from '@/play/game/systems.js';
import { cloneDeep, isString, uniq } from 'lodash';
import forEach from 'async/forEach.js';

function GameObjects() {
}

export default {
  inject: ['api'],
  props:{
    gamedata:{
      type: Object,
      required: true
    },
    enableInteractivity: {
      type: Boolean,
      default: false
    },
    timelimit: {
      type: Number,
      default: 5
    },
    backgroundColor: {
      type: String,
      default: '#313131'
    }
  },
  mounted() {
    console.log('gamedata', this.gamedata);
    this.allComponents = [];
    this.allLinks = [];
    for (let i = 0; i < (this.gamedata.scenes||[]).length; i++) {
      const scene = this.gamedata.scenes[i];
      this.allComponents.push(... scene.components);
      this.allLinks.push(... scene.links);
    }
    for (let i = 0; i < (this.gamedata.toybox||[]).length; i++) {
      const toy = this.gamedata.toybox[i];
      this.allComponents.push(... toy.components);
      this.allLinks.push(... toy.links);
    }

    this.allComponents.push(...(this.gamedata.components||[]));
    this.allLinks.push(...(this.gamedata.links||[]));


    // check for remixes
    this.i = Math.random();
    const dim = this.getDimensions();

    this.loader = new PIXI.Loader();

    const assets = this.buildAssets();
    console.log('have assets', assets);

    this.spritesTotal = assets.sprites.length;
    this.mipmappedTotal = assets.sprites.length;
    this.soundsTotal = assets.sounds.length;

    this.spritesLoaded = 0;
    this.soundsLoaded = 0;
    this.mipmappedLoaded = 0;

    assets.sprites.forEach( (asset) => {
      const img = asset;
      if (!img) {
        console.warn('have undefined as a sprite');
        return;
      }
      if (isString(img)) {
        if (this.hasPacker) {
          return;
        }
        let url;
        url = this.api.makeImageUrl(img);

        console.log('load', url);
        // load the texture wep need
        this.loader.add(img, url, {crossOrigin:true})
      } else {
        this.loader.add(img.name, img.b64);
      }
    })

    assets.videos.forEach( (video) => {
      const url = this.api.makeVideoUrl(video);
      if (url) {
        this.loader.add(video, url, {crossOrigin:true})
      }
    });
    assets.atlases.forEach( (atlas) => {
      const url = this.api.makeSpritesheetUrl(atlas);
      if (url) {
        this.loader.add(atlas, url, {crossOrigin:true})
      }
    });

    assets.spines.forEach( (spine) => {
      const url = this.api.makeSpineUrl(spine);
      if (url) {
        this.loader.add(spine, url, {crossOrigin:true})
      }
    });

    // stupid pixie loader doesn't do anything if there are no assets
    // so add a fake asset to make it load
    if (assets.sprites.length === 0) {
      this.loader.add('placeholder', this.api.makeImageUrl('placeholder.png'), {crossOrigin:true})
    }

    this.loader.on('progress', (progress) => {
      console.log('loading progress', progress);
      this.spritesLoaded = progress.progress/100 * assets.sprites.length;
      this.$emit('progress', {
        progress,
        total:assets.sprites.length
      });
    });
    this.loader.on('error', (err) => {
      console.error('error loading', err);
    });
    this.loader.load((loader, resources) => {
      console.log('finished loading');
      const errors = Object.values(resources).filter( (r) => {
        return r.error;
      }).map( (r) => {
        return r.error;
      });
      if (errors.length > 0) {
        console.error('error loading', errors);
        this.gameState = 'error';
        return this.$emit('error');
      }
      this.loader = loader;
      this.resources = resources;
      this.mipmappedTextures = {};


      if (this.hasPacker) {
        this.resources['game_EN_web'].children.forEach( (child) => {
          toPairs(child.textures).forEach( ([key,tex]) => {
            this.mipmappedTextures[key + '.png'] = tex;
            this.mipmappedTextures[key + '.jpg'] = tex;
          })
        })
      }
      console.log('for all the sprites', assets.sprites.length);
      forEach(assets.sprites, (sprite, callback) => {
        let name,img;
        console.log('sprite', sprite);
        if (!sprite) {
          console.warn('have undefined sprite');
          this.mipmappedLoaded++;
          setTimeout(callback, 0);
          return;
        }
        if (isString(sprite)) {
          if (this.hasPacker) {
            return setTimeout(callback, 0);
          }
          name = sprite;
          img = sprite;
          if (this.hasPacker) {
            return setTimeout(callback, 0)
          }
        } else {
          name = sprite.name;
          img = sprite.b64;
        }

        this.mipmappedTextures[name] = this.resources[name].texture;
        this.mipmappedLoaded++;

        callback();

      }, () => {
        console.log('done loading');
        this.gameState = 'playing';
        this.$emit('loaded');

        this.createGame();

      });
    });

  },
  beforeDestroy() {
    if (this.app) {
      this.app.ticker.remove(this.ticker.bind(this))
      this.app.ticker.stop();
      this.app.stop();

      for (var i = this.app.stage.children.length - 1; i >= 0; i--) {
        this.app.stage.removeChild(this.app.stage.children[i]);
      };
      this.app.stage.destroy(true);


      this.app.destroy();
      this.Systems.destroy();
      this.entityManager.removeAllEntities();
      delete this.entityManager;
      delete this.gameobjects;
      this.app = undefined;
    }
  },
  data() {
    return {
      isFirstFrame: true,
      timeSinceStart: 0,
    }
  },
  methods:{
    ticker() {
      const deltaTime = this.app.ticker.elapsedMS;
      if (this.isFirstFrame) {
        this.Systems.delayFirstRender = true;
        this.Systems.delayFirstRenderCounter = 0;
        this.isFirstFrame = false;
        return;
      }
      const dt = deltaTime;
      this.Systems.runSystems(dt);
      this.timeSinceStart += dt;

      if (this.timelimit > 0) {
        if (this.timeSinceStart / 1000 > this.timelimit) {
          this.restartGame(this.gamedata);
        }
      }

      //this.app.renderer.render(this.app.stage);

    },
    getDimensions() {
      if (!this.$el) {
        return {
          width:10,
          height:10
        }
      }
      const el = this.$el
      let bb = el.getBoundingClientRect();
      const boundingBox = {
        width:bb.width,
        top:bb.top,
        left:bb.left,
        right:bb.right,
        bottom:bb.bottom,
        height:bb.height,
      }

      let windowWidth = window.innerWidth;
      let windowHeight = window.innerHeight;
      if (window.visualViewport) {
        windowWidth = window.visualViewport.width;
        windowHeight = window.visualViewport.height;
      }
      return {
        // Math.min important for triviaforge-shell?
        height:Math.min(bb.height, windowHeight),
        width:Math.min(bb.width, windowWidth)
      }

    },
    buildAssets() {
      const assets = {
        sounds:[],
        sprites:[],
        atlases:[],
        spines:[],
        videos:[],
        tilesets:[]
      }
      function getAssetsFromComponent(c) {
        if (c.type === "sprite") {
          if (c.b64) {
            assets.sprites.push({
              b64:c.b64,
              name:c.id
            })
          } else {
            if (c.atlas) {
              assets.atlases.push(c.atlas);
            } else {
              assets.sprites.push(c.sprite);
            }
          }
        } else if (c.type === 'video') {
          assets.videos.push(c.video);
        } else if (c.type === 'spineTransform') {
          if (!isObject(c.spine)) {
            assets.spines.push(c.spine);
          }
        } else if (c.type === 'tiledSprite') {
          if (c.atlas) {
            assets.atlases.push(c.atlas);
          } else {
            assets.sprites.push(c.texture);
          }
        } else if (c.type === "playSound") {
          assets.sounds.push(c.sound);
        } else if (c.type === 'tileMap') {
          c.tiled.tilesets.forEach( (tileset) => {
            assets.atlases.push(tileset.name);
          });
        } else if (c.type === 'particleTransform') {
          assets.sprites.push(c.sprite);
        }
      }
      this.allComponents.forEach(getAssetsFromComponent);

      assets.sounds = uniq(assets.sounds);
      assets.sprites = uniq(assets.sprites);
      assets.videos = uniq(assets.videos);
      assets.tilesets = uniq(assets.tilesets);
      assets.atlases = uniq(assets.atlases);
      assets.spines = uniq(assets.spines);

      return assets;
    },
    createGame() {
      this.accumulator = 0;
      if (this.app) {
        this.cleanup();
      }
      const el = this.$el.querySelectorAll('.gamecanvas')[0];
      const dim = this.getDimensions();
      this.prevWidth = dim.width /= 1;
      this.prevHeight = dim.height /= 1;
      let forceCanvas = true;

      dim.width /= 1
      dim.height /= 1;

      this.app = new PIXI.Application({
        width:dim.width,
        height:dim.height,
        forceCanvas:true,
        preserveDrawingBuffer:false,
        transparent:false,
        legacy:false,
        antialias:false,
        resolution:1,
        autoResize:true,
        forceFXAA:false
      });
      el.appendChild(this.app.view);
      this.app.ticker.add(this.ticker.bind(this));

      this.appTicker = this.app.ticker;

      this.screenWidth = dim.width;
      this.screenHeight = dim.height;
      this.app.renderer.backgroundColor = parseInt(this.bgcolor.replace('#', '0x'));

      if (this.app.renderer.type === PIXI.RENDERER_TYPE.WEBGL) {
        this.rendererType = 'webgl';
      } else {
        this.rendererType = 'canvas';
      }

      // HEH?
      this.app.stage = new PIXI.display.Stage();
      this.app.stage.group.enableSort = true;
      this.app.stage.sortableChildren = true;

      this.app.stage.hitArea = new PIXI.Rectangle(-10000,-10000,20000,20000);

      const transformContainer = this.app.stage;
      const screenContainer = new PIXI.Container();
      if (this.enableWatermark) {
        this.addWatermark(screenContainer);
      }
      this.app.stage.addChild(screenContainer);

      if (this.enableInteractivity) {
        this.doEnableInteractivity();
      }

      this.entityManager = new EntityManager();

      this.initGame(this.loader, this.resources, this.sounds, this.mipmappedTextures);


    },
    initGame(loader, resources, sounds, mipmappedTextures) {

      let bb = this.$el.getBoundingClientRect();


      this.gameobjects = this.createGameObjects(loader, resources, sounds, mipmappedTextures);
      //this.$store.commit('gameobjects', this.gameobjects);
      this.Systems = new CreateSystems(this.gameobjects, {
        enableLetterbox:this.enableLetterbox
      }, this.app);
      if (typeof(this.initialTransforms) === 'undefined') {
        console.log('start 1');
        this.Systems.initFromScene(0, () => {
          this.startGame();
        });
      } else {
        console.log('start 2');
        this.Systems.initFromTransforms(this.initialTransforms, this.layers, () => {
          this.startGame();
        });
      }

    },
    startGame() {
      console.log('start game');
      this.Systems.initVariables(this.gamedata);

      this.timeSinceStart = 0;

      const dim = this.getDimensions();
      this.app.stage.position.set(dim.width/2,dim.height/2);
      this.app.stage.scale.set(0.4, 0.4);

      this.app.start();

      //setTimeout( () => {
        //this.Systems.resize(300,300);
      //});
    },
    createGameObjects(loader, resources, sounds, mipmappedTextures) {

      const dim = this.getDimensions();
      const topLevelComponents = this.gamedata.scenes[0].transforms;
      const centroid = {x:0,y:0}
      let x1 = 9999999;
      let y1 = 9999999;
      let x2 = -9999999;
      let y2 = -999999;
      (topLevelComponents||[]).forEach( (transform) => {
        const x = transform.transform.pos.x;
        const y = transform.transform.pos.y;
        
        if (x > x2) {
          x2 = x;
        }
        if (y > y2) {
          y2 = y;
        }
        if (x < x1) {
          x1 = x;
        }
        if (y < y1) {
          y1 = y;
        }
      });

      const o = new GameObjects();

      o.addDebug = () => { }
      o.userId = ((this.user||{}).identityId) || 'user';
      o.gameId = this.gameId;
      o.entities = this.entityManager;
      o.options = { }
      o.sounds = sounds;
      o.centroid = centroid;
      o.api = this.api;
      o.logStat = () => {}
      o.storeVariable = () => { }
      o.overrideCamera = this.overrideCamera;
      o.extents = {
        x1,
        x2,
        y1,
        y2
      };
      o.doToast = () => { }
      const toCache = {
        components:this.allComponents,
        links:this.allLinks
      }
      o.componentLinkCache = Util.prePopulateCache(toCache);
      o.componentIdCache = Util.prePopulateIdCache(toCache);
      o.graphics = this.graphics;
      o.componentLinkNamesCache = {};
      o.askUserInput = this.askUserInput;
      o.links = this.allLinks;
      o.components = this.allComponents;
      o.scenes = this.gamedata.scenes || [];
      o.collisions = this.gamedata.collisions;
      o.systems = this.gamedata.systems;
      o.system = this.gamedata.system;
      o.toybox = this.gamedata.toybox;
      o.features = this.gamedata.features;
      o.screenWidth = this.app.renderer.screen.width;
      o.screenHeight = this.app.renderer.screen.height;
      o.debugSelectTransform = this.debugSelectTransform;
      o.startScene = () => { };
      o.resumeScene = () => { };
      //o.setFirstFrame = this.setFirstFrame.bind(this);
      //o.gotoGame  = this.gotoGame.bind(this);
      o.loader = loader;
      o.resources = resources;
      o.mipmappedTextures = mipmappedTextures;
      o.DEBUG_DRAW = this.enableDebug;
      o.debugEntities = [];
      o.debugLogs = {};
      o.game = this.gamedata.game;
      o.setGameState =  (state, message) => {
        this.gameState = state;
        this.$emit("game-state", state, message);
      };
      o.updateLayersOrder = () => {
        return;
      };
      o.data = this.data;
      o.events = [];
      o.localEvents = {};
      o.debugLog = (o) => {
        if (this.enableDebug) {
          o.t = this.timeSinceStart
          this.$emit('debug-log', o);
        }
      }
      o.emitEvent = (event) => {
        this.gameobjects.events.push(event);
        this.$emit('event', {event,t:this.timeSinceStart});
      };
      o.emitLocalEvent = (ent, event) => {
        if (!ent || !ent.uuid) {
          return;
        }
        const uuid = ent.uuid.uuid;
        if (!this.gameobjects.localEvents[uuid]) {
          this.gameobjects.localEvents[uuid] = [];
        }
        this.gameobjects.localEvents[uuid].push(event);

      };
      o.app = this.app;
      o.toyExtensions = {};
      o.interaction = {}
      o.$store = this.$store;
      return o;
    },
    restartGame(gamedata) {
      this.timeSinceStart = 0;
      this.gamedata = gamedata;
      this.allComponents = [];
      this.allLinks = [];
      for (let i = 0; i < (this.gamedata.scenes||[]).length; i++) {
        const scene = this.gamedata.scenes[i];
        this.allComponents.push(... scene.components);
        this.allLinks.push(... scene.links);
      }
      for (let i = 0; i < (this.gamedata.toybox||[]).length; i++) {
        const toy = this.gamedata.toybox[i];
        this.allComponents.push(... toy.components);
        this.allLinks.push(... toy.links);
      }
      const toCache = {
        components:this.allComponents,
        links:this.allLinks
      }

      this.allComponents.push(...(this.gamedata.components||[]));
      this.allLinks.push(...(this.gamedata.links||[]));

      this.gameobjects.componentLinkCache = Util.prePopulateCache(toCache);
      this.gameobjects.componentIdCache = Util.prePopulateIdCache(toCache);
      this.gameobjects.links = this.allLinks;
      this.gameobjects.components = this.allComponents;

      if (typeof(this.initialTransforms) === 'undefined') {
        this.Systems.startWithScene(0);
      } else {
        this.Systems.startWithTransforms(this.initialTransforms, this.layers);
      }


    },
    resizeListener() {
      const el = this.$el.querySelectorAll('.gamecanvas')[0];
      if (el && this.app) {
        el.style.display = 'none'
        this.app.stop();
        this.pauseRender = true;

        const dim = this.getDimensions();
        var w = dim.width;
        var h = dim.height;

        setTimeout( () => {
          this.app.renderer.resize(w,h);
          this.Systems.resize(w,h);
          this.app.start();
        }, 800);
      }
    },
    doEnableInteractivity() {
      console.log('enable interactivity');
      const hammerOptions = {
        enablePan:true
      }
      /*
      const el = this.$el;
      this.hammer = new Hammer.Manager(el, {
        touchAction:'none'
      })
      const pan = new Hammer.Pan({
        threshold:15,
        pointers:1
      })
      const swipe =  new Hammer.Swipe({
        threshold:5,
        velocity:0.15
      })
      this.hammer.add(pan);
      this.hammer.add(swipe)

      pan.recognizeWith(swipe);
      */

      //this.hammer.on('panstart', this.onPanStart);
      //this.hammer.on('panmove', this.onPan);
      //this.hammer.on('panend', this.onPanEnd);
      //this.hammer.on('swipeleft', this.onSwipeDir.bind(this, 'left'));
      //this.hammer.on('swiperight', this.onSwipeDir.bind(this, 'right'));
      //this.hammer.on('swipeup', this.onSwipeDir.bind(this, 'up'));
      //this.hammer.on('swipedown', this.onSwipeDir.bind(this, 'down'));

      if (!hammerOptions.enablePan) {
        this.app.renderer.plugins.interaction.autoPreventDefault = false;
      }
      this.app.stage.interactive = true;
          //this.app.view.style['touch-action'] = 'none'
      //this.app.renderer.plugins.interaction.destroy();

      //this.app.stage.on('touchstart', this.onTap);
      this.app.stage.on('pointerdown', this.onPointerDown);
      this.app.stage.on('pointerup', this.onPointerUp);
      //window.addEventListener('pointerup', this.onPointerUpOutside);
    },
    onPointerDown(o) {
      console.log('on pointer down');
      if (this.gameobjects.interaction.press) {
        return;
      }
      console.log('on pointer down2');
      const pos = o.data.global;
      console.log('o', pos);

      this.Systems.pointerDown();
      this.gameobjects.interaction.press = {
        type:'press',
        pos:cloneDeep(pos)
      }
    },
    onPointerUpOutside() {
      console.log('pointer up yeah');
      this.Systems.pointerUpOutside();
    },
    onPointerUp(o) {
      if (this.gameobjects && this.gameobjects.interaction) {
        if (this.gameobjects.interaction.press) {
          const {x,y} = o.data.global;
          const x2 = this.gameobjects.interaction.press.pos.x;
          const y2 = this.gameobjects.interaction.press.pos.y;

          const xpart = (x2 - x);
          const ypart = (y2 - y);

          const dist = Math.sqrt(xpart * xpart + ypart * ypart);
          if (dist < 12) {
            //this.addDebug('tapped!');
            this.gameobjects.interaction.tap = cloneDeep(this.gameobjects.interaction.press);
          }
        }
        delete this.gameobjects.interaction.press;
      }
      this.Systems.pointerUp();
      //this.runInteractionSystems();
    },
    onTap(o) {
      o.stopPropagation();

      delete this.gameobjects.interaction.press;
      this.gameobjects.interaction.tap = {
        type:'tap',
        pos: clone(o.data.point)
      }

      this.runInteractionSystems();

      this.$emit('tap');
      //this.oneTick(new Date().getTime());

    },

  },
  computed:{
    bgcolor() {
      if (this.backgroundColor.length) {
        return this.backgroundColor;
      } else {
        return this.gamedata.game.bgcolor;
      }
    },
  }
}
</script>
